import React, { useEffect, useRef } from "react";
import PropTypes from "prop-types";
import moment from "moment";
import { Common } from "../../utils/common";

const $ = window.$;

function column_builder() {
  var columns = [];
  columns.push({
    data: null,
    render: function () {
      return "&nbsp;";
    },
    searchable: false,
    orderable: false,
    visible: true,
  });
  columns.push({
    data: "text_conversation_id",
    title: "Text_ID",
    searchable: true,
    orderable: true,
    visible: false,
  });
  columns.push({
    data: null,
    title: "Time of Text",
    render: function (data, type, row) {
      return moment.utc(row.created_at).local().format("MMM D, YYYY hh:mm:ss A");
    },
    searchable: true,
    orderable: true,
    visible: true,
  });
  columns.push({
    data: null,
    title: "Tracking",
    render: function (data, type, row) {
      return Common.formatPhoneNumber(row.did);
    },
    searchable: true,
    orderable: true,
  });
  columns.push({
    data: null,
    title: "Caller ID",
    render: function (data, type, row) {
      var result = Common.formatPhoneNumber(row.ani);
      return result;
    },
    searchable: true,
    orderable: true,
  });
  columns.push({
    data: "customer_name",
    title: "Customer Name",
    render: (data) => (data ? data.trim() : null),
  });
  columns.push({
    data: "address",
    title: "Address",
    searchable: true,
    orderable: true,
    visible: true,
  });
  columns.push({
    data: "message",
    title: "First Message",
    searchable: true,
    orderable: true,
    visible: false,
  });
  columns.push({
    data: "text_conversation_id",
    title: "Conversation",
    searchable: true,
    orderable: true,
    visible: true,
    render: (data) => {
      return `
        <button 
          id=${data}
          title='Click to view chat' 
          type='button' 
          class='view_text_conversation lead_modal btn btn-default btn-sm'
        >View</button>
      `;
    },
  });
  columns.push({
    data: "campaign_name",
    title: "Campaign Name",
    searchable: true,
    orderable: true,
    visible: true,
  });
  columns.push({
    data: "domain_name",
    title: "Domain Name",
    searchable: true,
    orderable: true,
    visible: false,
  });
  columns.push({
    data: "location_name",
    title: "Location Name",
    searchable: true,
    orderable: true,
    visible: true,
  });
  columns.push({ data: "name", title: "Team", searchable: true, orderable: true, visible: true });
  columns.push({
    data: "user_name",
    title: "Agent Name",
    searchable: true,
    orderable: true,
    visible: true,
  });
  columns.push({
    data: "distance_from_site",
    title: "Customer Distance",
    visible: false,
    render: (data, type) => {
      if (type === "display") {
        return data;
      } else {
        if (data) {
          return Number(data.split(" ")[0]);
        } else {
          return 9999999999999;
        }
      }
    },
  });
  columns.push({
    data: "status",
    title: "Status",
    searchable: true,
    orderable: true,
    visible: true,
  });
  columns.push({
    data: "existing_customer",
    title: "Existing Customer",
    searchable: true,
    orderable: true,
    visible: true,
  });
  columns.push({
    data: "is_lead",
    title: "Lead",
    searchable: true,
    orderable: true,
    visible: true,
  });
  columns.push({
    data: "request_type",
    title: "Request Type",
    searchable: true,
    orderable: true,
    visible: true,
  });
  columns.push({
    data: "appt_preference",
    title: "Appointment Preference",
    searchable: true,
    orderable: true,
    visible: true,
  });
  columns.push({
    data: "ref_domain",
    title: "Referral Domain",
    searchable: true,
    orderable: true,
    visible: false,
  });
  columns.push({
    data: "ref_medium",
    title: "Referral Medium",
    searchable: true,
    orderable: true,
    visible: false,
  });
  columns.push({
    data: "utm_source",
    title: "UTM Source",
    searchable: true,
    orderable: true,
    visible: false,
  });
  columns.push({
    data: "utm_medium",
    title: "UTM Medium",
    searchable: true,
    orderable: true,
    visible: false,
  });
  columns.push({
    data: "utm_campaign",
    title: "UTM Campaign",
    searchable: true,
    orderable: true,
    visible: false,
  });
  columns.push({
    data: "utm_content",
    title: "UTM Content",
    searchable: true,
    orderable: true,
    visible: false,
  });
  columns.push({
    data: "utm_term",
    title: "Keyword",
    searchable: true,
    orderable: true,
    visible: false,
  });
  columns.push({
    data: "url_href",
    title: "RAW URL",
    searchable: true,
    orderable: true,
    visible: false,
  });

  return columns;
}

const hideFromExport = [0];

function TextDetailsTable({ tableData }) {
  const tableEl = useRef(null);

  useEffect(() => {
    const $el = $(tableEl.current);
    const table = $el.DataTable({
      columns: column_builder(),
      dom: "<fB>tlip",
      keys: true,
      lengthMenu: [
        [10, 25, 50, 100, -1],
        [10, 25, 50, 100, "All"],
      ],
      fnRowCallback: function (nRow, aData, iDisplayIndex, iDisplayIndexFull) {
        var index = iDisplayIndexFull + 1 + ".";
        $("td:eq(0)", nRow).html(index);
        return nRow;
      },
      stateSaveCallback: function (oSettings, oData) {
        if (!Common.in_crm_mode()) {
          localStorage.setItem("DataTables-AI-Text_Details", JSON.stringify(oData));
        }
      },
      stateLoadCallback: function (oSettings) {
        if (!Common.in_crm_mode()) {
          return JSON.parse(localStorage.getItem("DataTables-AI-Text_Details"));
        }
      },
      order: [5, "asc"],
      stateSave: true,
      buttons: [
        {
          extend: "colvis",
          text: "Select Columns",
          titleAttr: "Select Columns",
          collectionLayout: "three-column",
          columns: ":gt(0)",
        },
        {
          extend: "excelHtml5",
          text: "Data Export",
          title: "Text_Details_Export",
          titleAttr: "Export as Excel",
          exportOptions: {
            columns: (i) => {
              const isVisible = table.column(i).visible();
              const isNotForExport = hideFromExport.includes(i);
              return isVisible && !isNotForExport ? true : false;
            },
          },
        },
      ],
      columnDefs: [{ className: "table_cell_centered_text", targets: "_all" }],
      paging: true,
      responsive: true,
      destroy: true,
    });
    table.clear();
    if (tableData) {
      table.rows.add(tableData).draw();
    }

    $(".table-responsive tbody").on("click", ".view_text_conversation", function () {
      const conversation_id = this.id;
      if (!conversation_id) return;

      $.ajax({
        type: "GET",
        url: "/text_conversation/" + conversation_id,
        dataType: "json",
        success: function (result) {
          $("#textdrill").modal("hide");
          var html = render_modal_content(result.html);
          $("#textdrill .modal-title").html(
            '<h4 class="text-center">' + " Text Conversation: " + "</h4>"
          );
          $("#textdrill .modal-body").html(html);
          $("#textdrill").modal("show");
        },
      });
    });

    return () => {
      // Destroys DataTable instance whenever component unmounts
      table.destroy();
      $el.empty();
    };
  }, [tableData]);

  return (
    <>
      <div className="table-responsive" style={{ paddingTop: "20px" }}>
        <table
          ref={tableEl}
          className="table table-hover table-striped vertical_centered table-bordered"
          style={{ width: "100%" }}
        ></table>
      </div>
      {/* Text conversation modal */}
      <div className="modal fade" id="textdrill" tabIndex="-1" role="dialog" aria-hidden="true">
        <div className="modal-dialog modal-chatdialog">
          <div className="modal-content">
            <div className="modal-header">
              <button type="button" className="close" data-dismiss="modal" aria-hidden="true">
                x
              </button>
              <h3 className="modal-title"></h3>
            </div>
            <div className="modal-body"></div>
            <div className="modal-footer">
              <button type="button" className="btn btn-primary" data-dismiss="modal">
                Close
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

function render_modal_content(text_data) {
  var html = '<div class="gg-chat-content">';
  for (var i = 0; i < text_data.length; i++) {
    var from_who = text_data[i].name;
    var type = text_data[i].message_type;
    var timestamp = text_data[i].created_at;
    var text = text_data[i].message;

    if (from_who != null && type == "T") {
      html += '<div class="gg-message gg-row gg-message--visitor gg-message--sms0 ">';
      html += '<div class="gg-message__img">';
      html += '<img src="https://cdn.gubagoo.io/v2/media/visitor.png" alt="operator">';
      html += "</div>";
      html += '<div class="gg-message__wrap">';
      html += '<div class="gg-message__author">Responder</div>';
      html += '<div class="gg-message__body">' + text + "</div>";
      html +=
        '<div class="gg-message__time">' + moment(timestamp).format("ddd M/D h:mm a") + "</div>";
      html += "</div>";
      html += "</div>";
    } else {
      if (type === "T") {
        html += '<div class="gg-message gg-row gg-message--operator gg-message--sms0 ">';
        html += '<div class="gg-message__img">';
        html += '<img src="https://cdn.gubagoo.io/v2/media/visitor.png" alt="customer">';
        html += "</div>";
        html += '<div class="gg-message__wrap">';
        html += '<div class="gg-message__author">Customer</div>';
        html += '<div class="gg-message__body">' + text + "</div>";
        html +=
          '<div class="gg-message__time">' + moment(timestamp).format("ddd M/D h:mm a") + "</div>";
        html += "</div>";
        html += "</div>";
      } else if (type === "N") {
        html += '<div class="internal chat-note">';
        html += '<span class="chatter">Note by : ' + from_who;
        html +=
          '<span class="chat-date">, ' + moment(timestamp).format("ddd M/D h:mm a") + "</span>";
        html += '<div class="internal-text">' + text + "</div>";
        html += "</span>";
        html += "</div>";
      } else if (type === "W") {
        if (from_who == null) {
          from_who = "Customer";
        }
        html += '<div class="internal secure-sent">';
        html += '<span class="chatter">Secure Chat by : ' + from_who;
        html +=
          '<span class="chat-date">, ' + moment(timestamp).format("ddd M/D h:mm a") + "</span>";
        html += "</span>";
        html += "</div>";
      } else {
        html += '<div class="internal internal-sent">';
        html += '<span class="chatter">Internal Chat by : ' + from_who;
        html +=
          '<span class="chat-date">, ' + moment(timestamp).format("ddd M/D h:mm a") + "</span>";
        html += '<div class="internal-text">' + text + "</div>";
        html += "</span>";
        html += "</div>";
      }
    }
  }
  html += "</div>";
  return html;
}

TextDetailsTable.propTypes = {
  tableData: PropTypes.array,
};

export default TextDetailsTable;
